export default {
  methods: {
    interaction () {
      document.removeEventListener('click', this.interaction);
      this.$store.dispatch('audio_initiate');
    },
    onResume () {
      console.log('app onResume', document.visibilityState);
      this.checkLocation();
    },
    init() {
      var app = this;
      console.log('app init');
      document.addEventListener('click', this.interaction);
      document.addEventListener('visibilitychange', function(){
        if (!document.hidden) app.onResume();
      })
      this.$store.commit('UPDATE_mail');
      this.$store.commit('GET_settings');
      this.$store.dispatch('getDrivers');
      this.$nextTick(() => {
        this.$store.dispatch('start_mail');
      })
      this.$bus.$on('logoutApp', this.logout);
      this.$bus.$on('reloadApp', this.reload);
      this.$bus.$on('getInfo', this.info);
      this.checkLocation();
    },
    reload () {
      window.location.reload();
    },
    logout () {
      this.$store.dispatch('logout');
      window.location.reload();
    },
    info (data) {
      if (data && navigator) {

        this.getPosition().then((position) => {
          let info = {
            platform: navigator.platform,
            browser: navigator.userAgent,
            position
          }
          this.$socket.client.emit('say', {to: data.from, from: data.to, info});
        }).catch((err) => console.log(err));
      }
    },
    getPosition () {
      if (navigator.geolocation) {
        return new Promise(
          (resolve, reject) => navigator.geolocation.getCurrentPosition((position) => {
            if(position.coords) {
              resolve({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              });
            } else reject({})
          }, reject)
        )
      } else {
        return new Promise(
          resolve => resolve('not suported')
        )
      }
    },
    checkLocation () {
      this.getPosition().catch((error) => {
        if (error.code == error.PERMISSION_DENIED) {
          this.$router.push({ path: 'denied', query: { error: 'location' }})
        }
      });
    }
  },
  created () {
    this.init();
    console.log('app created');
  }
}
